import ComponentCard from "../../components/common/ComponentCard";
import React from "react";
import PageMeta from "../../components/common/PageMeta";
import ExamOverViewListComponent from "../../components/overview/ExamOverViewListComponent";
import ListComponent from "../../components/common/ListComponent";

const ExamOverviewList = () => {
    return (
        <>
            <PageMeta title="Danh sách bài viết" description="Trang danh sách bài viết"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    {/*<ExamOverViewListComponent />*/}
                    <ListComponent type="3" router="exam-overview" />
                </ComponentCard>
            </div>
        </>
    );
};

export default ExamOverviewList;